function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var SEARCH_REMARKS = {
  BEGIN: 'SEARCH_REMARKS_BEGIN',
  SUCCESS: 'SEARCH_REMARKS_SUCCESS',
  FAILURE: 'SEARCH_REMARKS_FAILURE'
};
var SEARCH_REMARKS_EVENTS = [SEARCH_REMARKS.BEGIN, SEARCH_REMARKS.SUCCESS, SEARCH_REMARKS.FAILURE];
export var searchCustomerRemarksPromise = function searchCustomerRemarksPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, SEARCH_REMARKS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchRemarks',
    data: {},
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    hasUnavailableServiceHandler: true
  }).then(function (response) {
    dispatch(setCustomerRemarksServiceAvailability(true));
    return Promise.resolve(response);
  }).catch(function (error) {
    // NOTE: Since `hasUnavailableServiceHandler` is passed to `ThunkHelper`, determine whether
    // the upstream service actually failed and the default handler was bypassed so the customer
    // can continue to load with reduced functionality
    if (error.handleUnavailableService) {
      dispatch(setCustomerRemarksServiceAvailability(false));
    } else {
      dispatch(setCustomerRemarksServiceAvailability(true));
    }
    return Promise.reject(error);
  });
};
export var searchCustomerRemarks = function searchCustomerRemarks(customerId) {
  return function (dispatch) {
    return searchCustomerRemarksPromise(dispatch, customerId);
  };
};
export var EDIT_REMARK = {
  CLEAR: 'EDIT_REMARK_CLEAR',
  SET: 'EDIT_REMARK_SET'
};
export var clearRemarkBeingEdited = function clearRemarkBeingEdited() {
  return {
    type: EDIT_REMARK.CLEAR
  };
};
export var setRemarkBeingEdited = function setRemarkBeingEdited(remarkToEdit) {
  return {
    type: EDIT_REMARK.SET,
    payload: remarkToEdit
  };
};
export var UPDATE_REMARK = {
  BEGIN: 'UPDATE_REMARK_BEGIN',
  SUCCESS: 'UPDATE_REMARK_SUCCESS',
  FAILURE: 'UPDATE_REMARK_FAILURE'
};
var UPDATE_REMARK_EVENTS = [UPDATE_REMARK.BEGIN, UPDATE_REMARK.SUCCESS, UPDATE_REMARK.FAILURE];
export var updateCustomerRemarkPromise = function updateCustomerRemarkPromise(dispatch, data, requestObject) {
  return ThunkHelper(dispatch, UPDATE_REMARK_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateRemark',
    data: {
      Remark: data.remark
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  }, requestObject);
};
export var updateCustomerRemark = function updateCustomerRemark(data, requestObject) {
  return function (dispatch) {
    return updateCustomerRemarkPromise(dispatch, data, requestObject);
  };
};
export var CREATE_REMARK = {
  BEGIN: 'CREATE_REMARK_BEGIN',
  SUCCESS: 'CREATE_REMARK_SUCCESS',
  FAILURE: 'CREATE_REMARK_FAILURE'
};
var CREATE_REMARK_EVENTS = [CREATE_REMARK.BEGIN, CREATE_REMARK.SUCCESS, CREATE_REMARK.FAILURE];
export var createCustomerRemarkPromise = function createCustomerRemarkPromise(dispatch, data, requestObject) {
  return ThunkHelper(dispatch, CREATE_REMARK_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CreateRemark',
    data: {
      Remark: data.remark
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  }, requestObject);
};
export var createCustomerRemark = function createCustomerRemark(data, requestObject) {
  return function (dispatch) {
    return createCustomerRemarkPromise(dispatch, data, requestObject);
  };
};
export var SET_REMARKS_SERVICE_AVAILABILITY = 'SET_REMARKS_SERVICE_AVAILABILITY';
export var setCustomerRemarksServiceAvailability = function setCustomerRemarksServiceAvailability() {
  var serviceAvailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: SET_REMARKS_SERVICE_AVAILABILITY,
    payload: serviceAvailable
  };
};